/* ============================================================
   GLOBAL MARKET AND FASHION — gmf-main.js
   Vanilla JS. Sin dependencias. Idempotente (guard anti-doble-init).
   ============================================================ */
(function () {
  "use strict";
  if (window.__GMF_MAIN_LOADED__) return;
  window.__GMF_MAIN_LOADED__ = true;

  var reduceMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  /* -------- Utilidad de arranque robusta -------- */
  function ready(fn) {
    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", fn, { once: true });
    } else { fn(); }
  }

  /* ============================================================
     1) Reveal on scroll (IntersectionObserver)
     ============================================================ */
  function initReveal() {
    var els = document.querySelectorAll(".gmf-reveal");
    if (!els.length) return;
    if (reduceMotion || !("IntersectionObserver" in window)) {
      els.forEach(function (el) { el.classList.add("is-visible"); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add("is-visible");
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.14, rootMargin: "0px 0px -8% 0px" });
    els.forEach(function (el) { io.observe(el); });
  }

  /* ============================================================
     2) Count-up de métricas (data-gmf-count="2358")
     ============================================================ */
  function initCountUp() {
    var nums = document.querySelectorAll("[data-gmf-count]");
    if (!nums.length) return;
    if (reduceMotion || !("IntersectionObserver" in window)) {
      nums.forEach(function (n) { n.textContent = format(+n.getAttribute("data-gmf-count")); });
      return;
    }
    function format(v) { return v.toLocaleString("es-MX"); }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        var el = entry.target;
        io.unobserve(el);
        var target = +el.getAttribute("data-gmf-count");
        var dur = 1400, start = performance.now();
        (function step(now) {
          var p = Math.min((now - start) / dur, 1);
          var eased = 1 - Math.pow(1 - p, 3);
          el.textContent = format(Math.floor(eased * target));
          if (p < 1) requestAnimationFrame(step);
          else el.textContent = format(target);
        })(start);
      });
    }, { threshold: 0.6 });
    nums.forEach(function (n) { io.observe(n); });
  }

  /* ============================================================
     3) Acordeón FAQ (accesible)
     ============================================================ */
  function initAccordion() {
    var items = document.querySelectorAll("[data-gmf-accordion] .gmf-faq__item");
    if (!items.length) return;
    items.forEach(function (item) {
      var btn = item.querySelector(".gmf-faq__q");
      var panel = item.querySelector(".gmf-faq__a");
      if (!btn || !panel) return;
      btn.addEventListener("click", function () {
        var open = item.classList.contains("is-open");
        // Cierra hermanos dentro del mismo acordeón
        var root = item.closest("[data-gmf-accordion]");
        if (root && root.getAttribute("data-gmf-accordion") === "single") {
          root.querySelectorAll(".gmf-faq__item.is-open").forEach(function (o) {
            if (o !== item) {
              o.classList.remove("is-open");
              o.querySelector(".gmf-faq__q").setAttribute("aria-expanded", "false");
              o.querySelector(".gmf-faq__a").style.maxHeight = null;
            }
          });
        }
        item.classList.toggle("is-open", !open);
        btn.setAttribute("aria-expanded", String(!open));
        panel.style.maxHeight = open ? null : panel.scrollHeight + "px";
      });
    });
  }

  /* ============================================================
     4) Carrusel de testimonios (scroll-snap + flechas + dots)
     ============================================================ */
  function initCarousels() {
    document.querySelectorAll("[data-gmf-carousel]").forEach(function (root) {
      var track = root.querySelector(".gmf-carousel__track");
      if (!track) return;
      var prev = root.querySelector("[data-gmf-prev]");
      var next = root.querySelector("[data-gmf-next]");
      var dotsWrap = root.querySelector("[data-gmf-dots]");
      var slides = Array.prototype.slice.call(track.children);
      if (!slides.length) return;

      function slideStep() {
        var first = slides[0];
        var gap = parseFloat(getComputedStyle(track).columnGap || getComputedStyle(track).gap || 0) || 0;
        return first.getBoundingClientRect().width + gap;
      }
      function scrollByCards(dir) {
        track.scrollBy({ left: dir * slideStep(), behavior: reduceMotion ? "auto" : "smooth" });
      }
      if (prev) prev.addEventListener("click", function () { scrollByCards(-1); });
      if (next) next.addEventListener("click", function () { scrollByCards(1); });

      if (dotsWrap) {
        slides.forEach(function (_, i) {
          var d = document.createElement("button");
          d.className = "gmf-carousel__dot";
          d.type = "button";
          d.setAttribute("aria-label", "Ir al testimonio " + (i + 1));
          d.addEventListener("click", function () {
            track.scrollTo({ left: i * slideStep(), behavior: reduceMotion ? "auto" : "smooth" });
          });
          dotsWrap.appendChild(d);
        });
        var dots = dotsWrap.children;
        var updateDots = function () {
          var idx = Math.round(track.scrollLeft / slideStep());
          for (var i = 0; i < dots.length; i++) dots[i].classList.toggle("is-active", i === idx);
        };
        updateDots();
        track.addEventListener("scroll", throttle(updateDots, 120));
      }
    });
  }

  /* ============================================================
     5) Slider Antes / Después
     ============================================================ */
  function initBeforeAfter() {
    document.querySelectorAll("[data-gmf-ba]").forEach(function (root) {
      var range = root.querySelector(".gmf-ba__range");
      var after = root.querySelector(".gmf-ba__after");
      var handle = root.querySelector(".gmf-ba__handle");
      if (!range || !after) return;
      function apply(v) {
        after.style.clipPath = "inset(0 0 0 " + v + "%)";
        if (handle) handle.style.left = v + "%";
        range.setAttribute("aria-valuenow", Math.round(v));
      }
      range.addEventListener("input", function () { apply(+range.value); });
      apply(+range.value || 50);
    });
  }

  /* ============================================================
     6) Sticky cart (aparece al salir el hero, solo móvil)
     ============================================================ */
  function initStickyCart() {
    var bar = document.querySelector("[data-gmf-sticky]");
    if (!bar) return;
    var anchor = document.querySelector("[data-gmf-sticky-anchor]") ||
                 document.querySelector(".gmf-hero");
    if (!anchor || !("IntersectionObserver" in window)) { bar.classList.add("is-visible"); return; }
    var io = new IntersectionObserver(function (entries) {
      bar.classList.toggle("is-visible", !entries[0].isIntersecting);
    }, { threshold: 0 });
    io.observe(anchor);
  }

  /* ============================================================
     7) Parallax ligero (data-gmf-parallax="0.15")
     ============================================================ */
  function initParallax() {
    if (reduceMotion) return;
    var els = document.querySelectorAll("[data-gmf-parallax]");
    if (!els.length) return;
    var ticking = false;
    function update() {
      var vh = window.innerHeight;
      els.forEach(function (el) {
        var r = el.getBoundingClientRect();
        var speed = parseFloat(el.getAttribute("data-gmf-parallax")) || 0.12;
        var offset = (r.top + r.height / 2 - vh / 2) * -speed;
        el.style.transform = "translate3d(0," + offset.toFixed(1) + "px,0)";
      });
      ticking = false;
    }
    window.addEventListener("scroll", function () {
      if (!ticking) { requestAnimationFrame(update); ticking = true; }
    }, { passive: true });
    update();
  }

  /* -------- helpers -------- */
  function throttle(fn, wait) {
    var last = 0, t;
    return function () {
      var now = Date.now(), ctx = this, args = arguments;
      var remaining = wait - (now - last);
      if (remaining <= 0) { clearTimeout(t); last = now; fn.apply(ctx, args); }
      else { clearTimeout(t); t = setTimeout(function () { last = Date.now(); fn.apply(ctx, args); }, remaining); }
    };
  }

  /* -------- boot -------- */
  ready(function () {
    initReveal();
    initCountUp();
    initAccordion();
    initCarousels();
    initBeforeAfter();
    initStickyCart();
    initParallax();
  });

  // Reinicializa en el editor de temas al re-render de secciones
  document.addEventListener("shopify:section:load", function () {
    initReveal(); initCountUp(); initAccordion();
    initCarousels(); initBeforeAfter(); initStickyCart(); initParallax();
  });
})();
